/**
 * Sanitização do HTML gerado pelo editor rich text (TinyMCE) antes de renderizar com {@html}.
 *
 * O conteúdo é criado pelo próprio usuário logado (não é input de terceiros), mas ainda assim
 * removemos qualquer vetor de execução de script — tags <script>, atributos de evento inline
 * (onclick, onerror...) e URLs com protocolo javascript:/vbscript: em href/src — e reforçamos
 * a segurança de links externos com rel="noopener noreferrer".
 *
 * Usa o parser HTML nativo do navegador (DOMParser) em vez de regex: regex não consegue lidar
 * de forma confiável com HTML arbitrário (tags aninhadas, atributos quebrados, etc.).
 */

const REMOVED_TAGS = ['script', 'iframe', 'object', 'embed', 'style', 'link', 'meta']
const DANGEROUS_URL_PATTERN = /^\s*(javascript|vbscript|data):/i
const URL_ATTRIBUTES = ['href', 'src', 'xlink:href', 'action', 'formaction']

export function sanitizeHtml(html: string | null | undefined): string {
    if (!html) return ''

    const parsed = new DOMParser().parseFromString(html, 'text/html')

    for (const tag of REMOVED_TAGS) {
        parsed.querySelectorAll(tag).forEach((el) => el.remove())
    }

    parsed.body.querySelectorAll('*').forEach((el) => {
        for (const attr of Array.from(el.attributes)) {
            const name = attr.name.toLowerCase()
            if (name.startsWith('on')) {
                el.removeAttribute(attr.name)
                continue
            }
            if (URL_ATTRIBUTES.includes(name) && DANGEROUS_URL_PATTERN.test(attr.value)) {
                el.removeAttribute(attr.name)
            }
        }

        if (el.tagName === 'A' && el.hasAttribute('href')) {
            el.setAttribute('rel', 'noopener noreferrer nofollow')
        }
    })

    return parsed.body.innerHTML
}
